import Chip from '@mui/material/Chip'
import Colors from '../../../figma/panda/Colors'

const statusChipColor: Record<string, { bg: string; color: string }> = {
  RECEIVED: { bg: Colors.bluePrimary100, color: Colors.bluePrimary700 },
  PENDING: { bg: Colors.alert100, color: Colors.alert600 },
  ACCEPTED: { bg: Colors.success100, color: Colors.success700 },
  REJECTED: { bg: Colors.notificationErrors100, color: Colors.notificationErrors600 },
  FAILED: { bg: Colors.notificationErrors100, color: Colors.notificationErrors600 },
  CANCELLED: { bg: Colors.base300, color: Colors.base500 },
}

export const PisDepositStatusChip = ({ status }: { status?: string }) => {
  if (!status) return null
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: statusChipColor[status]?.bg,
        color: statusChipColor[status]?.color,
        fontWeight: 600,
        fontSize: 11,
        height: 20,
        letterSpacing: 0.3,
      }}
    />
  )
}
